import React from "react";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VerifiedUserOutlinedIcon from "@material-ui/icons/VerifiedUserOutlined";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import ExlyPopover from "common/Components/ExlyPopover";
import { useDesktopMediaQuery } from "features/Common/hooks/useDesktopMediaQuery";
import {
  PER_TIER_KYC_COPY,
  PER_TIER_KYC_STYLE,
} from "./PerTierKyc.constants";

const MenuAnchor = ({ openPopover, disabled }) => {
  const isDesktop = useDesktopMediaQuery();
  const handleClick = (event) => {
    if (disabled) return;
    openPopover(event);
  };
  return (
    <span className="tw-cursor-pointer" onClick={handleClick}>
      {isDesktop ? <MoreHorizIcon /> : <MoreVertIcon />}
    </span>
  );
};

const MenuItems = ({
  closePopover,
  onKycClick,
  onDeleteClick,
  showDelete,
  showKycItem,
}) => (
  <div className="tw-py-1 tw-min-w-[180px]">
    {showKycItem && (
      <div
        className="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-3 tw-cursor-pointer tw-text-sm tw-text-gray-900"
        onClick={() => {
          closePopover();
          if (onKycClick) onKycClick();
        }}
      >
        <VerifiedUserOutlinedIcon htmlColor={PER_TIER_KYC_STYLE.ICON_COLOR} />
        {PER_TIER_KYC_COPY.MENU_KYC}
      </div>
    )}
    {showDelete && (
      <div
        className="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-3 tw-cursor-pointer tw-text-sm tw-text-gray-900"
        onClick={() => {
          closePopover();
          if (onDeleteClick) onDeleteClick();
        }}
      >
        <DeleteOutlineIcon htmlColor={PER_TIER_KYC_STYLE.MENU_DELETE_COLOR} />
        {PER_TIER_KYC_COPY.MENU_DELETE}
      </div>
    )}
  </div>
);

export const KycRowActionsMenu = ({
  onKycClick,
  onDeleteClick,
  showDelete = true,
  showKycItem = true,
  disabled = false,
}) => {
  if (!showKycItem && !showDelete) return null;
  return (
    <ExlyPopover
      AnchorComponent={(anchorProps) => (
        <MenuAnchor {...anchorProps} disabled={disabled} />
      )}
      PopoverComponent={(popoverProps) => (
        <MenuItems
          {...popoverProps}
          onKycClick={onKycClick}
          onDeleteClick={onDeleteClick}
          showDelete={showDelete}
          showKycItem={showKycItem}
        />
      )}
    />
  );
};
